import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import {
  T, serif, fmt, Card, Chip, Boton, Titulo, Aviso, Vacio, Cargando,
} from '../lib/ui';

export function PanelSap() {
  const [estado, setEstado] = useState(null);
  const [aviso, setAviso] = useState(null);
  const [ocupado, setOcupado] = useState(false);

  const cargar = () => api.estadoSap().then(setEstado).catch(() => setEstado({ error: true }));

  useEffect(() => {
    cargar();
    const t = setInterval(cargar, 30_000);
    return () => clearInterval(t);
  }, []);

  const drenar = async () => {
    setOcupado(true);
    try {
      const r = await api.drenarSap();
      setAviso({
        tipo: r.fallidos > 0 ? 'warn' : 'ok',
        texto: r.procesados === 0
          ? 'No había nada pendiente en la cola.'
          : `${r.ok} enviado(s) a SAP · ${r.fallidos} con error` +
            (r.evitados ? ` · ${r.evitados} duplicado(s) evitado(s)` : ''),
      });
      await cargar();
    } catch {
      setAviso({ tipo: 'bad', texto: 'No se pudo procesar la cola.' });
    }
    setOcupado(false);
  };

  const reintentar = async (jobId) => {
    try {
      await api.reintentarSap(jobId);
      setAviso({ tipo: 'ok', texto: 'Reprogramado para el próximo ciclo.' });
      await cargar();
    } catch { setAviso({ tipo: 'bad', texto: 'No se pudo reprogramar.' }); }
  };

  if (!estado) return <Cargando />;

  const puente = estado.puente || {};
  const vivo = puente.alcanzable;

  return (
    <>
      <Titulo sub="Estado de la conexión con SAP Business One">SAP</Titulo>
      {aviso && <Aviso tipo={aviso.tipo}>{aviso.texto}</Aviso>}

      <Card style={{
        marginBottom: 16,
        borderLeft: `4px solid ${vivo ? T.ok : T.bad}`,
      }}>
        <div style={{
          display: 'flex', justifyContent: 'space-between',
          gap: 12, flexWrap: 'wrap', alignItems: 'center',
        }}>
          <div>
            <div style={{ fontWeight: 600, fontSize: 15, color: vivo ? T.ok : T.bad }}>
              {vivo ? 'Puente conectado' : 'Puente sin respuesta'}
            </div>
            <div style={{ color: T.muted, fontSize: 12, marginTop: 3 }}>
              {vivo
                ? `Servicio DI API de la oficina${puente.compania ? ` · ${puente.compania}` : ''}` +
                  (puente.sapConectado === false ? ' · sin sesión con SAP' : '')
                : puente.error || 'El servidor de la oficina no respondió.'}
            </div>
            <div style={{ color: T.muted, fontSize: 11, marginTop: 4 }}>
              Modo: {estado.modo === 'draft'
                ? 'borradores (contabilidad los revisa en SAP)'
                : 'documentos definitivos'}
            </div>
          </div>
          <Boton variante="acento" onClick={drenar} disabled={ocupado || !vivo}>
            {ocupado ? 'Enviando…' : 'Enviar cola a SAP'}
          </Boton>
        </div>

        {!vivo && (
          <div style={{ marginTop: 12, fontSize: 12, color: T.muted, lineHeight: 1.6 }}>
            Nada se pierde: los gastos aprobados quedan en cola y se envían
            cuando el servidor de la oficina vuelva a responder.
          </div>
        )}
      </Card>

      {estado.atascados > 0 && (
        <Aviso tipo="bad">
          {estado.atascados} trabajo(s) agotaron los reintentos y necesitan
          revisión manual.
        </Aviso>
      )}

      <h3 style={{ fontFamily: serif, fontSize: 18, color: T.navy, margin: '24px 0 12px' }}>
        Últimos movimientos
      </h3>

      {(!estado.recientes || estado.recientes.length === 0)
        ? <Vacio>Todavía no se ha enviado nada a SAP.</Vacio>
        : (
          <div style={{ display: 'grid', gap: 8 }}>
            {estado.recientes.map((j) => (
              <Card key={j.jobId} style={{ padding: 13 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
                  <div style={{ minWidth: 0, flex: 1 }}>
                    <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 3 }}>
                      <Chip estado={j.estado} />
                      <span style={{ fontSize: 12, fontWeight: 600 }}>{j.rindeId}</span>
                    </div>
                    <div style={{ color: T.muted, fontSize: 11 }}>
                      {j.objeto === 'PurchaseInvoices' ? 'Factura de proveedor'
                        : j.objeto === 'JournalEntries' ? 'Asiento contable'
                        : 'Alta de proveedor'}
                      {j.docNum && ` · SAP ${j.docNum}`}
                      {j.intentos > 1 && ` · ${j.intentos} intentos`}
                      {' · '}{fmt.fechaHora(j.createdAt)}
                    </div>
                    {j.mensajeB1 && j.estado === 'error' && (
                      <div style={{
                        fontSize: 11, color: T.bad, marginTop: 6, background: T.badBg,
                        padding: '6px 9px', borderRadius: 6, fontFamily: 'monospace',
                        wordBreak: 'break-word',
                      }}>
                        {j.codigoB1 ? `[${j.codigoB1}] ` : ''}{j.mensajeB1}
                      </div>
                    )}
                  </div>
                  {j.estado === 'error' && (
                    <Boton variante="suave" onClick={() => reintentar(j.jobId)}
                           style={{ fontSize: 12, padding: '5px 11px', alignSelf: 'flex-start' }}>
                      Reintentar
                    </Boton>
                  )}
                </div>
              </Card>
            ))}
          </div>
        )}
    </>
  );
}
